<div class="colors" [ngClass]="{'colors--active': active, 'colors__box-shadow': isBox}">
  <div class="colors__items">
    <rh-color [color]="color" *ngFor="let color of colorsPalette" [selectedColor]="selectedColor" (selectColor)="onSelectColor($event)" ></rh-color>
  </div>
</div>
